// Module
var code = "<div ng-controller=\"secureController as secureCtrl\"> <journey-viewer></journey-viewer> </div>";
// Exports
module.exports = code;